import { render, staticRenderFns } from "./SaleProformaView.vue?vue&type=template&id=36a50d6e"
import script from "./SaleProformaView.vue?vue&type=script&lang=js"
export * from "./SaleProformaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports